<button mat-icon-button (click)="fieldClick.emit($event)" class="text-accent" [disabled]="group.get(field.name).disabled">
  <app-icon name="remove_circle" type="MaterialDesign" size="sm" class="header-labels__icon"></app-icon>
</button>
